var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 12,
    fill: "#00D19F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2003_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1948 31.3685H39.2148C41.3448 31.3685 43.0848 29.6285 43.0848 27.5085C43.0848 25.3785 41.3448 23.6385 39.2148 23.6385C38.7948 23.6385 38.3948 23.7085 38.0148 23.8285C38.7048 24.8485 39.1048 26.0785 39.1048 27.4085C39.1148 28.7585 38.6948 30.0586 37.9048 31.1385C38.3148 31.2885 38.7448 31.3685 39.1948 31.3685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2748 31.3685H26.3048C26.7548 31.3685 27.1848 31.2885 27.5948 31.1385C26.8348 30.0986 26.3848 28.8085 26.3848 27.4085C26.3848 26.0785 26.7848 24.8485 27.4748 23.8285C27.0948 23.7085 26.6948 23.6385 26.2748 23.6385C24.1448 23.6385 22.4148 25.3785 22.4148 27.5085C22.4148 29.6285 24.1448 31.3685 26.2748 31.3685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7455 32.2746H32.7785C34.0735 32.2706 35.2895 31.7616 36.2015 30.8426C37.1145 29.9236 37.6145 28.7046 37.6095 27.4116C37.6095 24.7286 35.4285 22.5466 32.7455 22.5466C30.0634 22.5466 27.8824 24.7286 27.8824 27.4116C27.8824 30.0926 30.0634 32.2746 32.7455 32.2746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2249 32.8083C38.0849 32.8083 37.0149 33.0383 36.1149 33.4283C39.2649 34.3383 41.4949 36.5183 41.5549 39.0683C43.1949 38.8583 44.9649 38.2383 44.9649 36.5483C44.9649 34.5183 42.3349 32.8083 39.2249 32.8083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3749 33.4183C28.4749 33.0383 27.4049 32.8083 26.2749 32.8083C23.1649 32.8083 20.5349 34.5183 20.5349 36.5483C20.5349 38.2383 22.2949 38.8483 23.9349 39.0683C23.9849 36.5183 26.2149 34.3383 29.3749 33.4183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7445 34.4454C28.7835 34.4454 25.4365 36.6014 25.4365 39.1534C25.4365 42.4534 30.9365 42.4534 32.7445 42.4534C35.8825 42.4534 40.0545 42.1134 40.0545 39.1744C40.0545 36.6104 36.7065 34.4454 32.7445 34.4454Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2003_3005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20.5 20.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommon);
export default __webpack_public_path__ + "static/media/common.3ba232887715287762912dd4654470b1.svg";
export { ForwardRef as ReactComponent };